/**
 * Vista Exterior — Before / After Slider
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('[data-ve-ba-slider]');

    sliders.forEach(function (slider) {
      var clip = slider.querySelector('[data-ve-ba-clip]');
      var line = slider.querySelector('[data-ve-ba-line]');
      var handle = slider.querySelector('[data-ve-ba-handle]');
      if (!clip || !line || !handle) return;

      var isDragging = false;

      function getPercent(clientX) {
        var rect = slider.getBoundingClientRect();
        var x = clientX - rect.left;
        var pct = (x / rect.width) * 100;
        return Math.max(0, Math.min(100, pct));
      }

      function update(pct) {
        clip.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        line.style.left = pct + '%';
        handle.style.left = pct + '%';
      }

      function onStart(e) {
        e.preventDefault();
        isDragging = true;
        slider.style.cursor = 'grabbing';
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        update(getPercent(clientX));
      }

      function onMove(e) {
        if (!isDragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        update(getPercent(clientX));
      }

      function onEnd() {
        isDragging = false;
        slider.style.cursor = 'ew-resize';
      }

      slider.addEventListener('mousedown', onStart);
      slider.addEventListener('touchstart', onStart, { passive: false });
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: true });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);

      // Allow click to jump
      slider.addEventListener('click', function (e) {
        var clientX = e.clientX;
        update(getPercent(clientX));
      });
    });
  });
})();
